import React, { memo, useCallback, useEffect, useMemo, useRef } from 'react'
import { useSelector } from 'react-redux'
import {
  addTimeLineItem,
  updateTimeLineItem,
  deleteTimeLineItem
} from '../../../../../store/timeline/actions'
import {useEventSource} from '../../../../../hooks/useEventSource/useEventSource'
import {
  ActivityDataType,
  ActivityItem,
  ActivityItems,
  ActivityTimelineContextProps,
  ActivityTimelineSync as ActivityTimeline,
  ActivityTimelineContext,
  selectTimelineData,
  selectTimelineError,
  selectTimelineIsLoading
} from '../../../../../components/v2/activity-timeline'
import { useAppDispatch } from '../../../../../hooks/useAppDispatch/useAppDispatch'


interface AppealsTimeLineProps {
  className?: string
  id: string | number
  hideHeader?: boolean
}

export const AppealTimeline: React.FC<AppealsTimeLineProps> = memo((props: AppealsTimeLineProps) => {
  const { id, className, hideHeader } = props
  const dispatch = useAppDispatch()
  const timelineIsLoading = useSelector(selectTimelineIsLoading)
  const timelineError = useSelector(selectTimelineError)
  const timelineItems = useSelector(selectTimelineData)
  const { sse, subscribe } = useEventSource()

  const timelineItemsRef = useRef(timelineItems);
  
  useEffect(() => {
    timelineItemsRef.current = timelineItems;
  }, [timelineItems]);

  const handleAppealsTimelineNewItems = useCallback((newItems: ActivityItems[]) => {
    /* todo из-за манго колхозим проверку на соответствие type и id передаваемых и существующих элементов,
    *   подумать как оптимизировать
    * */
    newItems.forEach((newItem) => {
      const currentTimelineItems = timelineItemsRef.current;
      const scopeIndex = currentTimelineItems.itemsDates?.findIndex(date => date == newItem.date)
      
      if (scopeIndex === -1 || scopeIndex === undefined) {
        dispatch(addTimeLineItem([newItem]))
        return
      }
      if (!newItem?.items?.length) {
        return
      }

      const addItems: ActivityItem[] = []
      const updItems: DeepPartial<ActivityDataType>[] = []

      for (let newItemByType of newItem.items) {
        const newItemId = newItemByType.data?.id || newItemByType.id;
        let isExisting = false;
        for (let currentItemByType of currentTimelineItems.items[scopeIndex]?.items) {
          const currentItemId = currentItemByType.data?.id || currentItemByType.id;
          if (newItemByType.type === currentItemByType.type && newItemId === currentItemId) {
            updItems.push(newItemByType);
            isExisting = true;
            break;
          }
        }
        if (!isExisting) {
          addItems.push(newItemByType);
        }
      }

      if (addItems.length) {
        dispatch(addTimeLineItem([{ date: newItem.date, items: addItems }]))
      }

      if (updItems.length) {
        updItems.forEach(item => {
          dispatch(updateTimeLineItem({ date: newItem.date, data: item }))
        })
      }
    })
  }, [dispatch])

  useEffect(() => {
    if (id !== 'new') {
      subscribe(`/api/get-activity/live/case/${id}`, handleAppealsTimelineNewItems)
    }
    return () => sse?.current?.close()
  }, [id, subscribe, handleAppealsTimelineNewItems])

  const updateAppealsTimeline = useCallback(activityItem => {
    dispatch(updateTimeLineItem(activityItem))
  }, [])

  const deleteAppealsTimelineItem = useCallback(activityItem => {
    dispatch(deleteTimeLineItem(activityItem))
  }, [])

  const defaultProps = useMemo(
    (): ActivityTimelineContextProps => ({
      card_id: id,
      card_type: 'case',
      updateTimeline: updateAppealsTimeline,
      deleteTimelineItem: deleteAppealsTimelineItem
    }),
    [id],
  )

  return (
    <ActivityTimelineContext.Provider value={defaultProps}>
      <ActivityTimeline
        isLoading={timelineIsLoading}
        items={timelineItems?.items}
        error={timelineError !== '' ? (timelineError as Error)?.message || 'Неопределенная ошибка' : ''}
        className={className}
        hideHeader={hideHeader}
      />
    </ActivityTimelineContext.Provider>
  )
})
